/** The largest photo the API takes (R0032 Q-15) — a larger one is refused here, before it is sent. */
export const MAX_PHOTO_BYTES = 15 * 1024 * 1024;

/** Photos a product's gallery holds at most. */
export const MAX_GALLERY_PHOTOS = 30;

/** What the file picker offers; the API decides from the bytes, whatever the name or type says. */
export const PHOTO_ACCEPT = 'image/jpeg,image/png,image/webp,image/heic,image/heif,.heic,.heif';

/** The order after the photo `id` is moved to `index` — by dragging it there, or one step with a button. */
export const moveTo = (ids: Array<string>, id: string, index: number): Array<string> => {
  if (!ids.includes(id)) {
    return ids;
  }

  const others = ids.filter((one) => one !== id);
  const target = Math.max(0, Math.min(index, others.length));

  return [...others.slice(0, target), id, ...others.slice(target)];
};

/** The order after the photo `id` moves `step` places (−1 earlier, +1 later); unchanged at either end. */
export const moveBy = (ids: Array<string>, id: string, step: number): Array<string> =>
  moveTo(ids, id, ids.indexOf(id) + step);

/** Alt texts as a dialog edits them — every language, empty where none — and the changes a save sends. */
export const altChanges = (
  stored: Record<string, string | null>,
  edited: Record<string, string>,
): Record<string, string | null> => {
  const changes: Record<string, string | null> = {};

  for (const [locale, text] of Object.entries(edited)) {
    const next = text.trim() === '' ? null : text.trim();

    if (next !== (stored[locale] ?? null)) {
      changes[locale] = next;
    }
  }

  return changes;
};
